import { render, staticRenderFns } from "./buyerDetails.vue?vue&type=template&id=85a8b782&scoped=true&lang=html&"
import script from "./buyerDetails.vue?vue&type=script&lang=js&"
export * from "./buyerDetails.vue?vue&type=script&lang=js&"
import style0 from "./buyerDetails.vue?vue&type=style&index=0&id=85a8b782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a8b782",
  null
  
)

export default component.exports